import { Box, Container, Grid } from '@mui/material';
import React from 'react';

const LayoutLogin: React.FC = (props: any): JSX.Element => {
    const { children } = props;

    return (
        <Box
            height="100vh"
            sx={{
                background: `linear-gradient(to top, rgba(47, 68, 145, 1), rgba(185, 218, 251, 0))`, // ไล่สีเข้มจากล่างขึ้นบน
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundBlendMode: 'overlay',
                margin: 0,
                padding: 0,
            }}
        >
            <Container>
                <Grid xs={10}>
                    {children}
                </Grid>

            </Container>
        </Box>
    );
};

export default LayoutLogin;
